import { Goal } from 'data/records'
import { resource, member, collection, findSelector } from 'data/helpers/apiv3'
import { fulfilled } from 'lib/promiseMiddlewareHelpers'
import { Map, OrderedSet } from 'immutable'

const [api, actions] = resource(Goal, [
  ['read', member.get('', ['extras', 'privacyCode'])],
  ['list', collection.get('', ['clubId', 'scope'])],
  member.post('join', ['privacyCode']),
  member.post('copy')
])

const selectors = {
  ...findSelector(Goal),
  allForUser: (state, identifier) => {
    return state.apiv3.goal.getIn(['allForUser', identifier], OrderedSet())
      .map(cid => selectors.find(state, cid))
      .filter(Boolean)
  },
  metaForGoal: (state, goalId) => {
    return state.apiv3.goal.getIn(['metaForGoal', goalId], { community: {}, participants: {} })
  }
}

const reducers = {
  [fulfilled(actions.list.type)]: (state, action) => {
    const { identifier } = action.meta
    const nextAllForuser = state.getIn(['allForUser', identifier], OrderedSet()).concat(action.payload.results.map(r => r.id))
    return state.setIn(['allForUser', identifier], nextAllForuser)
  },
  [fulfilled(actions.read.type)]: (state, action) => {
    const { community, participants } = action.payload.meta
    return state.setIn(['metaForGoal', action.payload.goal.id], { community, participants })
  },
  [fulfilled(actions.join.type)]: (state, action) => {
    const { community } = action.payload.meta
    return state.mergeIn(['metaForGoal', action.payload.goalParticipant.goalId], { community })
  }
}

const freeReducers = {
  [fulfilled(actions.join.type)]: (v3state, action) => {
    const { goalParticipant: { goalId }, meta: { gp_ranks: gpRanks } } = action.payload
    const current = v3state.getIn(['goalParticipant', 'ranks', goalId])
    return v3state.mergeIn(['goalParticipant', 'ranks', goalId], { ...current, gpRanks })
  }
}

const initialState = {
  allForUser: Map(), // Map(identifier->OrderedSet([goalIds])) where identifier is a userId or club slug
  metaForGoal: Map() // Map(goalId -> meta object from show endpoint)
}

export {
  api as goalApi,
  actions as goalActions,
  selectors as goalSelectors,
  reducers as goalReducers,
  freeReducers as goalFreeReducers,
  initialState as goalInitialState
}
